package tta.destinigo.talktoastro.bottom_navigation

import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.value.Value
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesComponent
import tta.destinigo.talktoastro.feature_home.presentation.HomeScreenTabComponent
import tta.destinigo.talktoastro.feature_post.PostScreenComponent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenTabComponent
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreenComponent

interface BottomNavComponent {
    val stack: Value<ChildStack<*,BottomTabChild>>
    fun selectTab(index: Int)

    sealed class BottomTabChild{
        data class MoreScreenBottomTab(val component: MoreScreenTabComponent) : BottomTabChild()
        data class HomeScreenBottomTab(val component: HomeScreenTabComponent) : BottomTabChild()
        data class ExpertListBottomTab(val component: CoursesComponent) : BottomTabChild()
        data class FavoriteScreenBottomTab(val component: FavoriteScreenComponent): BottomTabChild()
        data class PostScreenBottomTab(val component: PostScreenComponent): BottomTabChild()
    }
}